import React, { useEffect, useRef } from "react";
import { Dialog, DialogActions, DialogContent } from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import BuyCatalogueList, { useBuyCatalogueList } from "../BuyCatalogueList";
import { Trans, useTranslation } from "react-i18next";

import Button from "@material-ui/core/Button";
import { useCheckout } from "../../providers/CheckoutProvider";
import CatalogueIcon from "../../../components/Icons/CatalogueIcon";

const useStyles = makeStyles((theme) => ({
  catalogueIconOuterContainer: {
    display: "flex",
    justifyContent: "center",
    textAlign: "center",
  },
  catalogueIconContainer: {
    width: "100px",
    height: "85px",
    "& > svg": {
      display: "block",
    },
  },
  header: {
    color: theme.palette.primary.dark,
    margin: 0,
    textAlign: "center",
  },
}));

export default ({ handleNextStep }) => {
  const { handleChange, catalogues } = useBuyCatalogueList();
  const classes = useStyles();
  const { buyCatalogues } = useCheckout();
  const { t } = useTranslation();

  const handleAddToCart = () => {
    const cats = catalogues.filter((catalogue) => catalogue.quantity > 0);

    if (cats.length == 0) {
      alert(
        t(
          "You need to select how many cataloges you would like before clicking Add to shopping cart"
        )
      );
      return;
    }

    buyCatalogues(cats).then(() => {
      handleNextStep();
    });
  };

  return (
    <Dialog open={true} fullWidth="sm">
      <DialogContent>
        <div className={classes.catalogueIconOuterContainer}>
          <div className={classes.catalogueIconContainer}>
            <CatalogueIcon />
          </div>
        </div>
        <h2 className={classes.header}>
          <Trans>Don't forget the catalogue</Trans>
        </h2>

        {catalogues && (
          <BuyCatalogueList
            catalogues={catalogues}
            handleChange={handleChange}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleNextStep}>
          <Trans>No thanks</Trans>
        </Button>
        <Button color="primary" onClick={handleAddToCart}>
          <Trans>Add to cart</Trans>
        </Button>
      </DialogActions>
    </Dialog>
  );
};
